module.exports = __webpack_public_path__ + "media/images/img_rounge_4-d6195148f011cf4f488568243f1c4387.jpg";